import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { config } from '../../config';
import Spinner from '../Global/Spinner';
import './scss/GitHubCallback.scss';

const GitHubCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const handleGitHubCallback = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const error = searchParams.get('error');
        const storedState = localStorage.getItem('github_oauth_state');

        localStorage.removeItem('github_oauth_state');

        if (error) {
          throw new Error(`GitHub OAuth error: ${error}`);
        }

        if (!code) {
          throw new Error('No authorization code received');
        }

        if (!state || state !== storedState) {
          throw new Error('Invalid state parameter');
        }

        // Get the action from localStorage (set by login/signup page)
        const action = localStorage.getItem('github_auth_action') || 'login';
        localStorage.removeItem('github_auth_action');

        const authResponse = await fetch(config.API_URI + '/v1/users/auth/github', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            code: code,
            action: action
          }),
        });

        if (!authResponse.ok) {
          const errorData = await authResponse.json();
          throw new Error(errorData.message || 'Authentication failed');
        }

        await authResponse.json();
        setStatus('success');

        // Get user data and redirect
        const userResponse = await fetch(config.API_URI + '/v1/users/me', {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });

        if (userResponse.ok) {
          const userData = await userResponse.json();
          const username = userData.user.username;

          setTimeout(() => {
            window.location.href = `/u/${username}/boards`;
          }, 1000);
        } else {
          setTimeout(() => {
            window.location.href = '/';
          }, 1000);
        }

      } catch (error) {
        console.error('GitHub OAuth error:', error);
        setStatus('error');

        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    };

    handleGitHubCallback();
  }, [searchParams, navigate]);

  return (
    <div className="github-callback-container">
      {status === 'processing' && (
        <>
          <Spinner size={40} strokeWidth={3} />
          <p className="callback-message">Authenticating with GitHub...</p>
        </>
      )}
      {status === 'success' && (
        <>
          <div className="success-icon">✓</div>
          <p className="callback-message">Success! Redirecting...</p>
        </>
      )}
      {status === 'error' && (
        <>
          <div className="error-icon">✗</div>
          <p className="callback-message">Authentication failed</p>
          <p className="redirect-message">Redirecting to login...</p>
        </>
      )}
    </div>
  );
};

export default GitHubCallback;
